function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTemplatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0070C5"
    },
    points: "39.385,94.041 347.227,0 466.185,79.572 472.615,417.152 144.682,512   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "361.673,20.429 57.193,104.157 154.451,485.499 454.197,399.386     454.197,81.983   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000355"
    },
    points: "466.185,79.572 362.515,104.157 347.227,0   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.578,
    y: 271.85,
    transform: "matrix(0.9568 -0.2909 0.2909 0.9568 -70.0145 93.7387)",
    style: {
      fill: "#000355"
    },
    width: 229.343,
    height: 20.975
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.907,
    y: 321.293,
    transform: "matrix(0.9568 -0.2909 0.2909 0.9568 -83.9509 98.8811)",
    style: {
      fill: "#000355"
    },
    width: 229.34,
    height: 20.976
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.849,
    y: 371.15,
    transform: "matrix(0.9567 -0.2909 0.2909 0.9567 -97.9831 104.2236)",
    style: {
      fill: "#000355"
    },
    width: 229.345,
    height: 20.975
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "85.203,113.329 204.963,81.983 226.663,189.688 106.901,225.052   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD500"
    },
    points: "97.033,120.976 115.909,210.119 211.869,184.949   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6969"
    },
    points: "129.543,117.306 146.323,171.84 206.627,158.731 197.187,99.478   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00D98D"
    },
    d: "M191.808,129.691c0,6.552-5.311,11.863-11.86,11.863c-6.551,0-11.863-5.311-11.863-11.863    c0-6.551,5.312-11.862,11.863-11.862C186.497,117.829,191.808,123.14,191.808,129.691z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTemplatesIcon);
export default __webpack_public_path__ + "static/media/dashboard_templates_icon.451aa439325b58e0cf75577b1319b446.svg";
export { ForwardRef as ReactComponent };